<app-crear-editar
  [title]="id ? 'Editar tema' : 'Crear tema'"
  [subtitle]="
    id
      ? form?.value?.nombre
      : 'Decorados y efecto festivo que se muestran en IRIX'
  "
  icono="palette"
  [loading]="loading || !form"
>
  @if (form) {
    <form [formGroup]="form" class="tema-form" autocomplete="off">
      <div class="tema-layout">
        <div class="form-pasos-layout tema-pasos">
          <app-pasos-nav
            [stepper]="stepper"
            etiqueta="Pasos del tema"
          ></app-pasos-nav>

          <mat-stepper #stepper [linear]="false" class="form-pasos-stepper">
            <!-- ── Datos ─────────────────────────────────────────────── -->
            <mat-step
              [stepControl]="form.controls['nombre']"
              errorMessage="Falta el nombre"
            >
              <ng-template matStepLabel>Datos</ng-template>
              <app-content-card title="Datos" icon="badge">
                <section class="inputs-group">
                  <mat-form-field style="width: 100%">
                    <mat-label>Nombre</mat-label>
                    <input matInput formControlName="nombre" required />
                  </mat-form-field>
                </section>
                <section class="inputs-group">
                  <mat-form-field style="width: 100%">
                    <mat-label>Descripción</mat-label>
                    <textarea
                      matInput
                      formControlName="descripcion"
                      rows="2"
                    ></textarea>
                  </mat-form-field>
                </section>
                <section class="inputs-group">
                  <div style="width: 100%">
                    <mat-form-field style="width: 100%">
                      <mat-label>Prioridad</mat-label>
                      <input
                        matInput
                        type="number"
                        formControlName="prioridad"
                        min="0"
                        max="100"
                      />
                    </mat-form-field>
                    <small class="ayuda">
                      De 0 a 100. Si hay varios temas vigentes a la vez, se
                      muestra el de mayor prioridad.
                    </small>
                  </div>
                  <div style="width: 100%" class="tema-toggle">
                    <mat-slide-toggle formControlName="activa" color="primary">
                      Activa
                    </mat-slide-toggle>
                    <small class="ayuda">
                      Sólo los temas activos se muestran, y únicamente dentro de
                      su período de activación.
                    </small>
                  </div>
                </section>
              </app-content-card>
            </mat-step>

            <!-- ── Activación ────────────────────────────────────────── -->
            <mat-step>
              <ng-template matStepLabel>Activación</ng-template>
              <app-content-card title="Activación" icon="event">
                <section class="inputs-group">
                  <mat-radio-group
                    formControlName="modoActivacion"
                    class="tema-modos"
                  >
                    <div>
                      <mat-radio-button value="permanente" color="primary">
                        Permanente
                      </mat-radio-button>
                      <small class="ayuda">
                        Se muestra siempre mientras esté activa.
                      </small>
                    </div>
                    <div>
                      <mat-radio-button value="rangoAbsoluto" color="primary">
                        Rango fijo de fechas
                      </mat-radio-button>
                      <small class="ayuda">
                        Se muestra sólo entre dos fechas puntuales.
                      </small>
                    </div>
                    <div>
                      <mat-radio-button value="recurrenteAnual" color="primary">
                        Recurrente anual
                      </mat-radio-button>
                      <small class="ayuda">
                        Se repite todos los años entre el mismo día y mes.
                      </small>
                    </div>
                  </mat-radio-group>
                </section>

                @if (form.value.modoActivacion === 'rangoAbsoluto') {
                  <section class="inputs-group">
                    <div style="width: 100%">
                      <app-date-picker
                        mode="daterange"
                        label="Rango de fechas"
                        formControlName="rangoFechas"
                      ></app-date-picker>
                    </div>
                  </section>
                }

                @if (form.value.modoActivacion === 'recurrenteAnual') {
                  <section class="inputs-group">
                    <div style="width: 100%">
                      <app-date-picker
                        mode="date"
                        label="Desde (día y mes)"
                        formControlName="recIniDate"
                      ></app-date-picker>
                    </div>
                    <div style="width: 100%">
                      <app-date-picker
                        mode="date"
                        label="Hasta (día y mes)"
                        formControlName="recFinDate"
                      ></app-date-picker>
                    </div>
                  </section>
                  <small class="ayuda">
                    Sólo se usan el día y el mes; el año se ignora. El período
                    puede cruzar el fin de año (por ejemplo, del 8 de diciembre
                    al 8 de enero).
                  </small>
                }
              </app-content-card>
            </mat-step>

            <!-- ── Decorados ─────────────────────────────────────────── -->
            <mat-step optional>
              <ng-template matStepLabel>Decorados</ng-template>
              <app-content-card title="Decorados" icon="image">
                <small class="ayuda tema-ayuda-seccion">
                  Imágenes PNG o WebP con fondo transparente, de hasta 1 MB.
                  @if (!id) {
                    Guardá el tema primero para poder subirlas.
                  }
                </small>

                <div class="tema-decorados">
                  @for (d of decorados; track d.slot) {
                    <div class="tema-decorado">
                      <div class="tema-decorado-imagen">
                        @if (urlDecal(d.slot); as url) {
                          <img [src]="url" alt="" />
                        } @else {
                          <span class="no-info">Sin imagen</span>
                        }
                      </div>
                      <div class="tema-decorado-textos">
                        <span class="tema-decorado-nombre">{{ d.nombre }}</span>
                        <small class="ayuda">{{ d.ayuda }}</small>
                      </div>
                      <div class="tema-decorado-acciones">
                        @if (d.tamano) {
                          <mat-form-field
                            class="tema-decorado-tamano"
                            subscriptSizing="dynamic"
                          >
                            <mat-label>Tamaño</mat-label>
                            <input
                              matInput
                              type="number"
                              [formControlName]="'decal' + d.slot + 'TamPct'"
                              min="0"
                              max="100"
                            />
                            <span matTextSuffix>%</span>
                          </mat-form-field>
                        }
                        <button
                          irxBoton="secundario"
                          type="button"
                          [disabled]="!id || subiendo"
                          (click)="fileInput.click()"
                        >
                          <mat-icon>upload</mat-icon>
                          Subir
                        </button>
                        <input
                          #fileInput
                          type="file"
                          accept="image/png,image/webp"
                          hidden
                          (change)="onUploadDecal(d.slot, $event)"
                        />
                      </div>
                      @if (d.tamano) {
                        <small class="ayuda tema-decorado-nota">
                          {{ d.tamano }}
                        </small>
                      }
                    </div>
                  }
                </div>
              </app-content-card>
            </mat-step>

            <!-- ── Efecto ────────────────────────────────────────────── -->
            <mat-step optional>
              <ng-template matStepLabel>Efecto</ng-template>
              <app-content-card
                title="Efecto de partículas"
                icon="auto_awesome"
              >
                <section class="inputs-group">
                  <div>
                    <mat-slide-toggle
                      formControlName="efectoActivo"
                      color="primary"
                    >
                      Mostrar partículas
                    </mat-slide-toggle>
                    <small class="ayuda">
                      Una imagen pequeña (copo, confeti, hoja) que cae sobre
                      toda la pantalla. Cada usuario puede apagarlo desde su
                      configuración.
                    </small>
                  </div>
                </section>

                @if (form.value.efectoActivo) {
                  <div class="tema-decorado tema-sprite">
                    <div class="tema-decorado-imagen">
                      @if (urlSprite(); as url) {
                        <img [src]="url" alt="" />
                      } @else {
                        <span class="no-info">Sin sprite</span>
                      }
                    </div>
                    <div class="tema-decorado-textos">
                      <span class="tema-decorado-nombre">Sprite</span>
                      <small class="ayuda">
                        PNG o WebP transparente, de hasta 1 MB.
                        @if (!id) {
                          Guardá el tema primero para poder subirlo.
                        }
                      </small>
                    </div>
                    <div class="tema-decorado-acciones">
                      <button
                        irxBoton="secundario"
                        type="button"
                        [disabled]="!id || subiendo"
                        (click)="fileSprite.click()"
                      >
                        <mat-icon>upload</mat-icon>
                        Subir
                      </button>
                      <input
                        #fileSprite
                        type="file"
                        accept="image/png,image/webp"
                        hidden
                        (change)="onUploadSprite($event)"
                      />
                    </div>
                  </div>

                  <section class="inputs-group">
                    <div style="width: 100%">
                      <mat-form-field style="width: 100%">
                        <mat-label>Cantidad</mat-label>
                        <input
                          matInput
                          type="number"
                          formControlName="efectoCantidad"
                          min="1"
                          max="128"
                        />
                      </mat-form-field>
                      <small class="ayuda">De 1 a 128 partículas.</small>
                    </div>
                    <div style="width: 100%">
                      <mat-form-field style="width: 100%">
                        <mat-label>Drift</mat-label>
                        <input
                          matInput
                          type="number"
                          formControlName="efectoDrift"
                        />
                        <span matTextSuffix>px</span>
                      </mat-form-field>
                      <small class="ayuda">
                        Desvío lateral al caer; 0 cae en línea recta.
                      </small>
                    </div>
                  </section>
                  <section class="inputs-group">
                    <mat-form-field style="width: 100%">
                      <mat-label>Velocidad mínima</mat-label>
                      <input
                        matInput
                        type="number"
                        formControlName="efectoVelMin"
                      />
                      <span matTextSuffix>s</span>
                    </mat-form-field>
                    <mat-form-field style="width: 100%">
                      <mat-label>Velocidad máxima</mat-label>
                      <input
                        matInput
                        type="number"
                        formControlName="efectoVelMax"
                      />
                      <span matTextSuffix>s</span>
                    </mat-form-field>
                  </section>
                  <small class="ayuda">
                    Segundos que tarda una partícula en cruzar la pantalla: a
                    menos segundos, más rápida.
                  </small>
                  <section class="inputs-group">
                    <mat-form-field style="width: 100%">
                      <mat-label>Tamaño mínimo</mat-label>
                      <input
                        matInput
                        type="number"
                        formControlName="efectoTamMin"
                      />
                      <span matTextSuffix>px</span>
                    </mat-form-field>
                    <mat-form-field style="width: 100%">
                      <mat-label>Tamaño máximo</mat-label>
                      <input
                        matInput
                        type="number"
                        formControlName="efectoTamMax"
                      />
                      <span matTextSuffix>px</span>
                    </mat-form-field>
                  </section>
                }
              </app-content-card>
            </mat-step>
          </mat-stepper>
        </div>

        <!-- ── Vista previa (esquema del shell y del login) ─────────────── -->
        <aside class="tema-preview" aria-label="Vista previa del tema">
          <span class="tema-preview-titulo">Vista previa</span>

          <div class="mini-shell">
            <div class="mini-barra">
              <img class="mini-logo" [src]="logoIrix" alt="IRIX" />
              @if (preview?.payload?.decalTopbar?.urlAsset; as urlTopbar) {
                <img
                  class="mini-decal-barra"
                  [src]="urlTopbar"
                  [style.height.%]="
                    preview?.payload?.decalTopbar?.tamanoPct ?? 70
                  "
                  alt=""
                />
              }
              <span class="mini-espacio"></span>
              <span class="mini-punto"></span>
              <span class="mini-punto"></span>
            </div>
            <div class="mini-cuerpo">
              <div class="mini-menu">
                <div class="mini-usuario">
                  <app-decal
                    [decal]="preview?.payload?.decalAvatar"
                    anchor="cover"
                  >
                    <span class="mini-avatar">AB</span>
                  </app-decal>
                  <span class="mini-linea" style="width: 60%"></span>
                </div>
                @for (i of [1, 2, 3, 4, 5]; track i) {
                  <span class="mini-item"></span>
                }
              </div>
              <div class="mini-hoja">
                <span class="mini-linea" style="width: 45%"></span>
                <span class="mini-bloque"></span>
                <span class="mini-linea" style="width: 80%"></span>
                <span class="mini-linea" style="width: 65%"></span>
              </div>
            </div>
            <app-tema-overlay
              [efecto]="efectoMini"
              [contenido]="true"
            ></app-tema-overlay>
          </div>
          <small class="ayuda">Menú lateral, barra superior y hoja.</small>

          <div class="mini-login">
            <app-decal
              [decal]="preview?.payload?.decalLogoLogin"
              anchor="top-right"
            >
              <img class="mini-login-logo" [src]="logoIrix" alt="IRIX" />
            </app-decal>
            <app-decal
              [decal]="preview?.payload?.decalLogin"
              anchor="bottom-right"
            >
              <span class="mini-login-tarjeta">
                <span class="mini-linea" style="width: 70%"></span>
                <span class="mini-campo"></span>
                <span class="mini-campo"></span>
                <span class="mini-boton"></span>
              </span>
            </app-decal>
          </div>
          <small class="ayuda">
            Pantalla de ingreso. Además, mientras editás, el tema se aplica en
            vivo a toda la aplicación.
          </small>
        </aside>
      </div>
    </form>
  }

  @if (form && stepper) {
    <ng-container actions>
      <button irxBoton="secundario" type="button" (click)="volver()">
        Cancelar
      </button>
      <span class="pie-espacio"></span>
      <button
        irxBoton="secundario"
        type="button"
        (click)="stepper.previous()"
        [disabled]="stepper.selectedIndex === 0"
      >
        <mat-icon>chevron_left</mat-icon>
        Anterior
      </button>
      @let ultimo = stepper.selectedIndex === stepper.steps.length - 1;
      <!-- Con el formulario válido, Guardar es la acción principal y
           Siguiente pasa a secundario -->
      @if (!ultimo && form.valid) {
        <button irxBoton="secundario" type="button" (click)="stepper.next()">
          Siguiente
          <mat-icon iconPositionEnd>chevron_right</mat-icon>
        </button>
      } @else if (!ultimo) {
        <button irxBoton="principal" type="button" (click)="stepper.next()">
          Siguiente
          <mat-icon iconPositionEnd>chevron_right</mat-icon>
        </button>
      }
      <button
        irxBoton="principal"
        type="button"
        (click)="guardar()"
        [disabled]="guardando || form.invalid"
      >
        <mat-icon>save</mat-icon>
        Guardar
      </button>
    </ng-container>
  }
</app-crear-editar>
